export var PORTAL_MOUNT_EVENT = 'akPortalMount';
export var PORTAL_UNMOUNT_EVENT = 'akPortalUnmount';
//# sourceMappingURL=constants.js.map